import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Brandfolder from './containers/Brandfolder/Brandfolder';
import Brandfolders from './containers/Brandfolders/Brandfolders';
import Attachments from './containers/Attachments/Attachments';
import GettingStarted from './containers/GettingStarted/GettingStarted';
import Welcome from './containers/Welcome/Welcome';
import { BRANDFOLDER, BRANDFOLDERS, GETTING_STARTED, WELCOME, ATTACHMENTS } from './actions';

class App extends Component {
  static propTypes = {
    page: PropTypes.string.isRequired
  };

  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm1" />
          <div className="ms-Grid-col ms-sm10">
            {this.props.page === BRANDFOLDER && <Brandfolder />}
            {this.props.page === BRANDFOLDERS && <Brandfolders />}
            {this.props.page === ATTACHMENTS && <Attachments />}
            {this.props.page === GETTING_STARTED && <GettingStarted />}
            {this.props.page === WELCOME && <Welcome />}
          </div>
          <div className="ms-Grid-col ms-sm1" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  page: state.page.page
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js